function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { connect } from 'react-redux';

import { unselectMessage, reportMessage, hideNotEnabledPopup, hideValidationPopup, markMessageAsInappropriate, closeReportOnMessage } from './../chatroomActions';

import { config } from './../../../conf/config';

var reportModal = function (_Component) {
    _inherits(reportModal, _Component);

    function reportModal() {
        var _temp, _this, _ret;

        _classCallCheck(this, reportModal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.modalCancelHandler = function () {
            var dispatch = _this.props.dispatch;

            dispatch(unselectMessage());
        }, _this.modalReportHandler = function () {
            var _this$props = _this.props,
                dispatch = _this$props.dispatch,
                selectedMessage = _this$props.selectedMessage;

            dispatch(reportMessage(selectedMessage['id']));
            dispatch(unselectMessage());
        }, _this.modalAdminMarkAsInappropriateHandler = function () {
            var _this$props2 = _this.props,
                dispatch = _this$props2.dispatch,
                selectedMessage = _this$props2.selectedMessage;

            dispatch(markMessageAsInappropriate(selectedMessage['id']));
            dispatch(unselectMessage());
        }, _this.modalAdminCloseReportHandler = function () {
            var _this$props3 = _this.props,
                dispatch = _this$props3.dispatch,
                selectedMessage = _this$props3.selectedMessage;

            dispatch(closeReportOnMessage(selectedMessage['id']));
            dispatch(unselectMessage());
        }, _this.modalReportValidationPopup = function () {
            var dispatch = _this.props.dispatch;

            dispatch(hideValidationPopup());
        }, _this.modalShowNotEnabledPopupHandler = function () {
            var dispatch = _this.props.dispatch;

            dispatch(hideNotEnabledPopup());
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    reportModal.prototype.render = function render() {
        var _props = this.props,
            selectedMessage = _props.selectedMessage,
            isAdmin = _props.isAdmin,
            showNotEnabledPopup = _props.showNotEnabledPopup,
            showValidationPopup = _props.showValidationPopup;


        var showModal = showNotEnabledPopup || selectedMessage['id'] !== false || showValidationPopup;

        var clickHandler = this.modalCancelHandler;
        var modal = React.createElement(
            'div',
            { className: 'modal-container' },
            React.createElement('div', { className: 'close-button', onClick: this.modalCancelHandler }),
            React.createElement('div', { className: 'image' }),
            React.createElement(
                'p',
                null,
                'Ce commentaire t\'a d\xE9plu? Signale le nous'
            ),
            React.createElement(
                'button',
                { className: 'danger', onClick: this.modalReportHandler },
                'Oui'
            ),
            React.createElement(
                'button',
                { className: 'no-button', onClick: this.modalCancelHandler },
                'Non'
            )
        );

        if (isAdmin) {
            modal = React.createElement(
                'div',
                { className: 'modal-container' },
                React.createElement('div', { className: 'close-button', onClick: this.modalCancelHandler }),
                React.createElement('div', { className: 'image' }),
                React.createElement(
                    'p',
                    null,
                    'ce commentaire doit-il \xEAtre cach\xE9 ?'
                ),
                React.createElement(
                    'button',
                    { className: 'yes-button', onClick: this.modalAdminMarkAsInappropriateHandler },
                    'Oui'
                ),
                React.createElement(
                    'button',
                    { className: 'no-button', onClick: this.modalAdminCloseReportHandler },
                    'Non'
                )
            );
        }

        if (showValidationPopup) {
            clickHandler = this.modalReportValidationPopup;
            modal = React.createElement(
                'div',
                { className: 'modal-container confirm' },
                React.createElement('div', { className: 'close-button', onClick: this.modalReportValidationPopup }),
                React.createElement('div', { className: 'image' }),
                React.createElement(
                    'p',
                    null,
                    'Merci,',
                    React.createElement('br', null),
                    ' on va s\'en occuper'
                )
            );
        }

        if (showNotEnabledPopup) {
            clickHandler = this.modalShowNotEnabledPopupHandler;
            modal = React.createElement(
                'div',
                { className: 'modal-container' },
                React.createElement(
                    'p',
                    null,
                    'Cette fonctionnalit\xE9 n\'est pas disponible'
                ),
                React.createElement(
                    'button',
                    { className: 'danger', onClick: this.modalShowNotEnabledPopupHandler },
                    'Ok'
                )
            );
        }

        return React.createElement(
            'div',
            null,
            showModal ? React.createElement('div', { className: 'modal-backdrop', onClick: clickHandler }) : null,
            React.createElement(
                'div',
                {
                    className: 'modal-panel' + (showValidationPopup ? ' validation' : '') + (isAdmin ? ' admin' : ''),
                    style: {
                        transform: showModal ? 'translateY(0)' : 'translateY(-100vh)',
                        opacity: showModal ? '1' : '0'
                    } },
                modal
            )
        );
    };

    return reportModal;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        selectedMessage: state.chatroom.selectedMessage,
        isAdmin: state.user.isAdmin,
        showNotEnabledPopup: state.chatroom.showNotEnabledPopup,
        showValidationPopup: state.chatroom.showValidationPopup
    };
};

export default connect(mapStateToProps)(reportModal);


//////////////////
// WEBPACK FOOTER
// ./node_modules/nm-react-chat/es/components/Chatroom/ReportModal/ReportModal.js
// module id = 103
// module chunks = 0